import { RootState } from "core-integration/src/store";
import { getElementTypesById } from "core-integration/src/store/element-types/reducers";
import { getElements } from "core-integration/src/store/elements/reducers";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import orderBy from "lodash/orderBy";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import BoldLink from "../../BoldLink";
import ElementDialogButton from "../../ElementDialogButton";
import { ElementRow, PrimaryCell } from "../../ElementTable";
import { Ellipsis } from "../../Utils";
import StatusPanel from "../StatusPanel";
import {
  ArrowCol,
  BodyArrowIn,
  BodyArrowOut,
  ClubCol,
  PlayerCol,
  PosCol,
  StatusCol,
  TransfersCol,
  TransfersPanelHeading,
  TransfersTable,
} from "./styles";
import { TransferPanelProps } from "./types";

const TransfersPanel = ({ isOut }: TransferPanelProps) => {
  const { t } = useTranslation();
  const elements = useSelector((state: RootState) => getElements(state));
  const elementTypesById = useSelector((state: RootState) =>
    getElementTypesById(state),
  );
  const teamsById = useSelector((state: RootState) => getTeamsById(state));
  const stat = isOut ? "transfers_out_event" : "transfers_in_event";

  const transferStatus = isOut
    ? t("transfersPanel.out", "Out")
    : t("transfersPanel.in", "In");

  return (
    <StatusPanel>
      <StatusPanel.Header
        link={
          <BoldLink to={`/statistics/${stat}`} variant="light">
            {t("transfersPanel.more", "More")}
          </BoldLink>
        }
      >
        <TransfersPanelHeading>
          {t("transfersPanel.heading", "Top Transfers {{ inOut }}", {
            inOut: transferStatus,
          })}
        </TransfersPanelHeading>
      </StatusPanel.Header>
      <StatusPanel.Body>
        <TransfersTable>
          <thead>
            <tr>
              <StatusCol>&nbsp;</StatusCol>
              <ArrowCol>&nbsp;</ArrowCol>
              <PosCol>{t("transfersPanel.postitionShort", "Pos")}</PosCol>
              <PlayerCol>{t("transfersPanel.player", "Player")}</PlayerCol>
              <ClubCol>{t("transfersPanel.club", "Club")}</ClubCol>
              <TransfersCol>&nbsp;</TransfersCol>
            </tr>
          </thead>
          <tbody>
            {orderBy(elements, [stat], ["desc"])
              .slice(0, 5)
              .map((e) => (
                <ElementRow key={e.id}>
                  <td>
                    <ElementDialogButton elementId={e.id} variant="list" />
                  </td>
                  <PrimaryCell>
                    {isOut ? <BodyArrowOut /> : <BodyArrowIn />}
                  </PrimaryCell>
                  <PrimaryCell>
                    {elementTypesById[e.element_type].singular_name_short}
                  </PrimaryCell>
                  <td>
                    <Ellipsis>{e.web_name}</Ellipsis>
                  </td>
                  <PrimaryCell>{teamsById[e.team].short_name}</PrimaryCell>
                  <PrimaryCell>{e[stat]}</PrimaryCell>
                </ElementRow>
              ))}
          </tbody>
        </TransfersTable>
      </StatusPanel.Body>
    </StatusPanel>
  );
};

export default TransfersPanel;
